import {
    CSSProperties,
    ChangeEventHandler,
    KeyboardEventHandler,
    RefObject,
    useContext,
    useRef,
    ReactNode,
    useState,
} from "react";
import { emailLogo, phoneLogo, calenderIcon } from "../../../../assets/assetsSVG";
// import QuestContext from "../../components/QuestWrapper";

import "./css/InputModule.css";
import { useOnboarding } from "../modular/OnboardingContext";

const LogoType = {
    email: emailLogo,
    phone: phoneLogo,
    text: () => <></>,
    number: phoneLogo,
    date: calenderIcon,
};

export type logoType = keyof typeof LogoType;

interface PropType {
    placeholder?: string;
    // type: keyof typeof LogoType;
    style?: CSSProperties | undefined;
    onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
    onKeyUp?: KeyboardEventHandler<HTMLInputElement> | undefined;
    onKeyDown?: KeyboardEventHandler<HTMLInputElement> | undefined;
    iconColor?: string;
    value?: string;
    logoPosition?: "left" | "right" | "both";
    ref?: RefObject<HTMLInputElement>;
    emailErrorStyle?: CSSProperties | undefined;
    emailtext?: string;
    required?: boolean;
    regexKey?: string | undefined,
    regexMessage?: string,
    name?: string;
    preventFutureSelection?: boolean;
    preventPastSelection?: boolean;
    children?: ReactNode;
    className?: string;
    key?: string | number | undefined;
    validateInputRegex?: (validated: boolean) => void
}

export const EmailInputModule = ({
    placeholder,
    // type = "email",
    onChange,
    iconColor,
    value,
    onKeyUp,
    onKeyDown,
    ref,
    logoPosition = "right",
    emailErrorStyle,
    emailtext,
    required,
    regexKey,
    regexMessage,
    name,
    preventFutureSelection,
    preventPastSelection,
    key,
    style,
    validateInputRegex = () => { }
}: PropType) => {
    const { themeManager } = useOnboarding()
    const [isValidEmail, setIsValidEmail] = useState(true);

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const fallbackPattern = emailPattern;

    const isValidRegex = (pattern: string | undefined): boolean => {
        try {
            new RegExp(pattern || '')
            return true;
        } catch {
            return false;
        }
    };
    
    const emailRegex = !regexKey ? fallbackPattern : isValidRegex(regexKey) ? new RegExp(regexKey) : fallbackPattern;

    const validateEmail = (inputValue: string) => {
        if (inputValue) {
            setIsValidEmail(emailRegex.test(inputValue));
            validateInputRegex(emailRegex.test(inputValue));
        } else {
            setIsValidEmail(true);
            validateInputRegex(true);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        validateEmail(inputValue);
        if (onChange) {
            onChange(e);
        }
    };

    const handleInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        if (!!regexKey) {
            validateEmail(inputValue);
        }
    };

    return (
        <>
            <div className="q_input_cont" style={style}>
                {(logoPosition == "left" || logoPosition == "both") &&
                    // LogoType[type](iconColor || "#B9B9B9")}
                    LogoType["email"](iconColor || "#B9B9B9")}
                <input
                    type={"email"}
                    name={name}
                    placeholder={placeholder}
                    className="q_input_main_cont"
                    onChange={handleInputChange}
                    onKeyUp={onKeyUp}
                    onKeyDown={onKeyDown}
                    // value={value}
                    defaultValue={value}
                    ref={ref}
                    onBlur={handleInputBlur}
                    onWheel={(event) => {
                        event.currentTarget.blur();
                    }}
                    style={{
                        fontFamily: themeManager?.getFontFamily() || "'Figtree', sans-serif",
                        color: style?.color,
                    }}
                    required={required}
                    // pattern={(type === "email" || !!regexKey) ? emailRegex.source : undefined}
                    pattern={(!!regexKey) ? emailRegex.source : undefined}
                    key={key}
                />
                {(logoPosition == "right" || logoPosition == "both") &&
                    // LogoType[type](iconColor || "#B9B9B9")}
                    LogoType["email"](iconColor || "#B9B9B9")}
            </div>
            {/* {(type === "email" || !!regexKey) && !isValidEmail && ( */}
            {!isValidEmail && (
                <span style={emailErrorStyle} className="q-input-error-message">
                    {regexMessage || emailtext}
                </span>
            )}
        </>
    );
};
